export default __webpack_public_path__ + "static/media/f4.c72524b3.svg";